<template>
  <div class="main-container">
    <!-- 左侧导航 -->
    <div class="sidebar">
      <!-- 顶部logo区域 -->
      <div class="logo-container">
        <img :src="shopLogo" alt="商户端" class="logo-img" />
        <h1 class="logo-title" v-if="!isCollapse">{{ shopName }}</h1>
      </div>

      <!-- 左侧导航 -->
      <el-menu class="nav-menu" :default-active="activeMenu" :background-color="menuBgColor" text-color="#a0a8b8"
        active-text-color="#00f2fe" router :collapse="isCollapse" unique-opened>
        <!-- 控制台 -->
        <el-menu-item index="/dashboard">
          <el-icon>
            <Monitor />
          </el-icon>
          <span>控制台</span>
        </el-menu-item>

        <!-- 账号管理 -->
        <el-menu-item index="/account">
          <el-icon>
            <User />
          </el-icon>
          <span>账号管理</span>
        </el-menu-item>

        <!-- 广告商管理 -->
        <el-menu-item index="/Advertiser">
          <el-icon>
            <Document />
          </el-icon>
          <span>广告管理</span>
        </el-menu-item>

        <!-- 素材管理 -->
        <el-sub-menu index="/material">
          <template #title>
            <el-icon>
              <Picture />
            </el-icon>
            <span>素材管理</span>
          </template>

          <el-menu-item index="/material/gallery">
            <el-icon>
              <Picture />
            </el-icon>
            <span>图库管理</span>
          </el-menu-item>
        </el-sub-menu>

        <!-- 系统配置子菜单 -->
        <el-sub-menu index="/system">
          <template #title>
            <el-icon>
              <Setting />
            </el-icon>
            <span>系统配置</span>
          </template>

          <el-menu-item index="/system/publish">
            <el-icon>
              <SetUp />
            </el-icon>
            <span>基础设置</span>
          </el-menu-item>
        </el-sub-menu>
      </el-menu>
    </div>

    <!-- 右侧内容区 -->
    <div class="content-wrapper">
      <!-- 固定在顶部的导航栏 -->
      <div class="top-navbar fixed-top">
        <div class="nav-center">
          <div class="info-item points">
            <el-icon class="icon">
              <Star />
            </el-icon>
            <span class="label">点数:</span>
            <span class="value">{{ points === -1 ? '无限制' : points.toFixed(1) }}</span>
          </div>
          <div class="info-item auth">
            <el-icon class="icon">
              <Key />
            </el-icon>
            <span class="label">授权数:</span>
            <span class="value">{{ sqNum === -1 ? '无限制' : sqNum }}</span>
          </div>
          <div class="info-item expire">
            <el-icon class="icon">
              <Calendar />
            </el-icon>
            <span class="label">过期时间:</span>
            <span class="value">{{ formattedOutDate }}</span>
          </div>
        </div>

        <div class="nav-right">
          <el-dropdown trigger="hover">
            <div class="user-info">
              <el-avatar :size="30" :src="userAvatar" />
              <span class="username">{{ username }}</span>
              <el-icon class="arrow-icon">
                <ArrowDown />
              </el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="showCardRechargeDialog">
                  <el-icon>
                    <CreditCard />
                  </el-icon>卡密充值
                </el-dropdown-item>
                <el-dropdown-item @click="handleModifyPassword">
                  <el-icon>
                    <Edit />
                  </el-icon>修改密码
                </el-dropdown-item>
                <el-dropdown-item divided @click="handleLogout">
                  <el-icon>
                    <SwitchButton />
                  </el-icon>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>

      <!-- 主内容区 -->
      <div class="main-content-container">
        <div class="main-content">
          <router-view />
        </div>
      </div>
    </div>
  </div>

  <!-- 卡密充值对话框 -->
  <el-dialog v-model="showCardDialog" title="卡密充值" width="400px" :close-on-click-modal="false">
    <el-form :model="cardForm" label-width="80px">
      <el-form-item label="卡密">
        <el-input v-model="cardForm.code" placeholder="请输入充值卡密" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="showCardDialog = false">取 消</el-button>
      <el-button type="primary" @click="submitCardRecharge">确 定</el-button>
    </template>
  </el-dialog>

  <el-dialog v-model="showPasswordDialog" title="修改密码" width="400px" :close-on-click-modal="false">
    <el-form :model="form" label-width="80px">
      <el-form-item label="旧密码">
        <el-input v-model="form.oldPwd" type="password" placeholder="请输入旧密码" show-password />
      </el-form-item>
      <el-form-item label="新密码">
        <el-input v-model="form.newPwd" type="password" placeholder="请输入新密码" show-password />
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input v-model="form.confirmPwd" type="password" placeholder="请再次输入新密码" show-password />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="showPasswordDialog = false">取 消</el-button>
      <el-button type="primary" @click="submitPassword">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import {
  Monitor,
  User,
  Document,
  Picture,
  CreditCard,
  SetUp
} from '@element-plus/icons-vue'
import { ref, computed, onMounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Cookies from 'js-cookie'
import config from '@/config'
import axios from 'axios'
import { Star, Key, Calendar } from '@element-plus/icons-vue'
// 在这里添加 ModuleStatus 接口定义



export default {
  name: 'MainLayout',
  components: {
    Monitor,
    CreditCard,
    User,
    Document,
    Picture,
    SetUp,
    Star,
    Key,
    Calendar
  },

  setup() {
    const router = useRouter()


    // 正确的 ref 定义（去掉多余空格）
    const moduleStatus = ref({
      tweet_template: 2,
      writing_model: 2,
      media_model: 2,
      title_api: 2,
      ai_agent: 2,
      storage_config: 2
    });
    const userInfo = JSON.parse(Cookies.get('user_info') || '{}')
    const account = userInfo.account || ''
    const isLoggedIn = ref(!!Cookies.get('user_token'))
    const shopLogo = ref('@/assets/logo.gif') // 默认logo
    const shopName = ref('商户端') // 默认名称
    const menuBgColor = ref('transparent')
    const isCollapse = ref(false)
    const points = ref(0) // 初始化为0
    const sqNum = ref(0)
    const outDate = ref('')
    const formattedOutDate = computed(() => outDate.value.split(' ')[0] || '未设置')
    const userAvatar = ref('https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png')
    const username = ref(account)

    const activeMenu = computed(() => {
      const route = router.currentRoute.value
      const matched = route.matched
      return matched.length > 1 ? `/${matched[0].path.split('/')[1]}` : route.path
    })
    const showPasswordDialog = ref(false)
    const form = reactive({
      oldPwd: '',
      newPwd: '',
      confirmPwd: ''
    })
    const showCardDialog = ref(false)
    const cardForm = reactive({
      code: ''
    })

    // 显示卡密充值对话框
    const showCardRechargeDialog = () => {
      cardForm.code = ''
      showCardDialog.value = true
    }

    // 获取模块权限状态
    const fetchModuleStatus = async () => {
      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/module_hidden.php`, {
          store_id: userInfo.id
        });

        if (response.data.data) {
          moduleStatus.value = response.data.data;
        }
      } catch (error) {
        console.error('获取模块权限失败:', error);
        // 使用默认全选状态
        moduleStatus.value = {
          tweet_template: 2,
          writing_model: 2,
          media_model: 2,
          title_api: 2,
          ai_agent: 2,
          storage_config: 2
        };
      }
    };

    // 提交卡密充值
    const submitCardRecharge = async () => {
      if (!cardForm.code) {
        ElMessage.error('请输入卡密')
        return
      }

      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'recharge_card',
          account: account,
          code: cardForm.code
        })

        if (response.data.success) {
          ElMessage.success('充值成功')
          // 刷新点数信息
          await loadPoints()
          showCardDialog.value = false
        } else {
          ElMessage.error(response.data.message || '充值失败')
        }
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '请求失败')
      }
    }

    // 加载点数数据
    const loadPoints = async () => {
      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'query',
          account: account
        })

        if (response.data.success) {
          points.value = parseFloat(response.data.data.dianshu || 0)
          sqNum.value = parseInt(response.data.data.sq_num) || 0 // 新增 parseInt 转换

          outDate.value = response.data.data.out_date || ''

        } else {
          ElMessage.error('点数加载失败: ' + (response.data.message || '未知错误'))
        }
      } catch (error) {
        ElMessage.error('接口请求失败: ' + error.message)
      }
    }

    // 修改密码方法
    const submitPassword = async () => {
      // 前端验证
      if (!form.oldPwd) {
        ElMessage.error('请输入旧密码')
        return
      }
      if (!form.newPwd) {
        ElMessage.error('请输入新密码')
        return
      }
      if (form.newPwd !== form.confirmPwd) {
        ElMessage.error('两次输入的新密码不一致')
        return
      }

      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'update_password',
          account: account,
          old_password: form.oldPwd,
          new_password: form.newPwd
        })

        if (response.data.success) {
          ElMessage.success('密码修改成功，请重新登录')
          // 清除登录状态
          Cookies.remove('user_token')
          router.push('/login')
        } else {
          ElMessage.error(response.data.message || '密码修改失败')
        }
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '请求失败')
      } finally {
        showPasswordDialog.value = false
      }
    }

    // 修改密码按钮点击事件
    const handleModifyPassword = () => {
      // 重置表单
      Object.assign(form, {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      })
      showPasswordDialog.value = true
    }

    // 加载店铺信息
    const loadShopInfo = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/shop/api/web_icon.php`)
        if (response.data.success) {
          shopLogo.value = response.data.data.shop_logo || '@/assets/logo.gif'
          shopName.value = response.data.data.shop_name || '商户端'
        }
      } catch (error) {
        console.error('加载店铺信息失败:', error)
        // 使用默认值
        shopLogo.value = '@/assets/logo.gif'
        shopName.value = '商户端'
      }
    }


    onMounted(() => {
      loadPoints()
      loadShopInfo() // 新增：加载店铺信息
      fetchModuleStatus(); // 新增：加载模块权限


    })

    const handleNavClick = (type) => {
      const messages = {
        distribution: '分销中心正在开发中，请稍后...',
        discount: '优惠套餐正在开发中，请稍后...'
      }
      ElMessage.info(messages[type] || '功能开发中')
    }
    const handleLogout = async () => {
      try {
        // 二次确认弹窗
        await ElMessageBox.confirm(
          '确定要退出登录吗？所有未保存数据将会丢失！',
          '警告',
          {
            confirmButtonText: '确认退出',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'logout-confirm',
            closeOnClickModal: false
          }
        )

        // 清除登录状态
        Cookies.remove('user_token')
        Cookies.remove('user_info')
        isLoggedIn.value = false

        // 跳转登录页并提示
        router.push('/login')
        ElMessage.success('您已安全退出系统')
      } catch (error) {
        // 用户取消退出时不执行操作
        if (error !== 'cancel') {
          ElMessage.error('退出操作失败，请重试')
        }
      }
    }

    return {
      menuBgColor,
      isCollapse,
      points,
      userAvatar,
      username,
      activeMenu,
      sqNum,          // 新增
      formattedOutDate, // 新增
      handleLogout,
      handleNavClick,
      showPasswordDialog,
      form,
      showCardDialog,
      cardForm,
      showCardRechargeDialog,
      submitCardRecharge,
      submitPassword,
      shopLogo,
      shopName,
      moduleStatus,
      userInfo,
      handleModifyPassword
    }
  }
}
</script>

<style scoped lang="scss">
.main-container {
  display: flex;
  background: linear-gradient(135deg, 
    #0c0e29 0%, 
    #1a1f3d 25%, 
    #252a4a 50%, 
    #1e233f 75%, 
    #141732 100%);
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

// 添加科技感背景效果
.main-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 80%, rgba(0, 242, 254, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(148, 0, 211, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(255, 0, 128, 0.05) 0%, transparent 50%);
  pointer-events: none;
}

// 添加网格背景
.main-container::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    linear-gradient(rgba(0, 242, 254, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0, 242, 254, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  pointer-events: none;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-input {
  width: 100%;
}

.sidebar {
  width: 260px;
  background: linear-gradient(195deg, 
    rgba(16, 20, 48, 0.95) 0%, 
    rgba(26, 31, 61, 0.9) 50%, 
    rgba(20, 24, 50, 0.85) 100%);
  backdrop-filter: blur(10px);
  box-shadow: 
    4px 0 25px rgba(0, 0, 0, 0.3),
    inset -1px 0 0 rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(0, 242, 254, 0.1);
  position: relative;
  z-index: 10;
  transition: width 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  .logo-container {
    padding: 28px 0;
    border-bottom: 1px solid rgba(0, 242, 254, 0.15);
    text-align: center;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 25%;
      width: 50%;
      height: 2px;
      background: linear-gradient(90deg, 
        transparent 0%, 
        #00f2fe 50%, 
        transparent 100%);
    }

    .logo-img {
      width: 48px;
      height: 48px;
      border-radius: 8px;
      box-shadow: 
        0 8px 25px rgba(0, 242, 254, 0.3),
        0 0 0 1px rgba(0, 242, 254, 0.2);
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      filter: brightness(1.1);
    }

    .logo-title {
      margin: 16px 0 0;
      font-size: 18px;
      font-weight: 700;
      letter-spacing: 1px;
      background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-shadow: 0 2px 10px rgba(0, 242, 254, 0.3);
    }
  }
}

.nav-menu {
  --el-menu-bg-color: transparent;
  --el-menu-hover-bg-color: rgba(0, 242, 254, 0.08);
  padding: 16px 12px;
  height: auto;
  position: relative;

  :deep(.el-submenu__title),
  :deep(.el-menu-item) {
    height: 50px;
    margin: 6px 0;
    border-radius: 12px;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    padding: 0 20px !important;
    display: flex !important;
    align-items: center;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      width: 3px;
      background: linear-gradient(180deg, #00f2fe 0%, #4facfe 100%);
      transform: scaleY(0);
      transition: transform 0.3s ease;
    }

    .el-icon {
      font-size: 18px;
      flex-shrink: 0;
      width: 24px;
      margin-right: 12px;
      color: #a0a8b8;
      transition: all 0.3s ease;
    }

    &:hover {
      background: rgba(0, 242, 254, 0.08) !important;
      transform: translateX(8px);
      box-shadow: 0 4px 15px rgba(0, 242, 254, 0.2);

      .el-icon {
        color: #00f2fe;
        transform: scale(1.1);
      }

      &::before {
        transform: scaleY(1);
      }
    }
  }

  :deep(.el-sub-menu) {
    .el-sub-menu__icon-arrow {
      right: 12px !important;
      margin-top: -7px !important;
      color: #a0a8b8;
      transition: all 0.3s ease;
    }

    .el-sub-menu__title span {
      margin-left: -1px;
    }

    &:hover .el-sub-menu__icon-arrow {
      color: #00f2fe;
    }
  }

  :deep(.el-menu-item .el-icon),
  :deep(.el-sub-menu__title .el-icon) {
    margin-right: 12px !important;
  }

  :deep(.el-menu-item)>span,
  :deep(.el-submenu__title)>span {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    font-weight: 500;
  }

  :deep(.el-menu-item.is-active) {
    background: linear-gradient(90deg, 
      rgba(0, 242, 254, 0.15) 0%, 
      rgba(79, 172, 254, 0.05) 100%) !important;
    box-shadow: 
      inset 0 0 20px rgba(0, 242, 254, 0.1),
      0 4px 15px rgba(0, 242, 254, 0.2);

    &::before {
      transform: scaleY(1);
    }

    .el-icon {
      color: #00f2fe;
    }
  }

  :deep(.el-sub-menu) {
    .el-menu-item {
      padding-left: 52px !important;
      position: relative;

      &::before {
        left: 20px;
        width: 2px;
        background: linear-gradient(180deg, #4facfe 0%, #00f2fe 100%);
      }
    }

    .el-menu-item.is-active {
      padding-left: 50px !important;
    }
  }
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.fixed-top {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 70px;
  background: rgba(16, 20, 48, 0.85);
  backdrop-filter: blur(15px);
  border-bottom: 1px solid rgba(0, 242, 254, 0.15);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
  box-shadow: 
    0 4px 30px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.05);

  .nav-center {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-left: auto;

    .info-item {
      display: flex;
      align-items: center;
      padding: 10px 20px;
      border-radius: 12px;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;
      backdrop-filter: blur(10px);
      border: 1px solid transparent;
      background: linear-gradient(135deg, 
        rgba(255, 255, 255, 0.1) 0%, 
        rgba(255, 255, 255, 0.05) 100%);

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, 
          transparent, 
          rgba(255, 255, 255, 0.1), 
          transparent);
        transition: left 0.6s ease;
      }

      .icon {
        font-size: 16px;
        margin-right: 10px;
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
      }

      .label {
        font-weight: 600;
        margin-right: 6px;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
      }

      .value {
        font-weight: 700;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
      }

      &.points {
        color: #00f2fe;
        border-color: rgba(0, 242, 254, 0.3);
        box-shadow: 
          0 4px 15px rgba(0, 242, 254, 0.2),
          inset 0 1px 0 rgba(0, 242, 254, 0.1);

        .icon {
          color: #00f2fe;
        }
      }

      &.auth {
        color: #00d4ff;
        border-color: rgba(0, 212, 255, 0.3);
        box-shadow: 
          0 4px 15px rgba(0, 212, 255, 0.2),
          inset 0 1px 0 rgba(0, 212, 255, 0.1);

        .icon {
          color: #00d4ff;
        }
      }

      &.expire {
        color: #ff6b9d;
        border-color: rgba(255, 107, 157, 0.3);
        box-shadow: 
          0 4px 15px rgba(255, 107, 157, 0.2),
          inset 0 1px 0 rgba(255, 107, 157, 0.1);

        .icon {
          color: #ff6b9d;
        }
      }

      &:hover {
        transform: translateY(-3px);
        box-shadow: 
          0 8px 25px rgba(0, 242, 254, 0.3),
          inset 0 1px 0 rgba(255, 255, 255, 0.2);

        &::before {
          left: 100%;
        }
      }
    }
  }

  .user-info {
    display: flex;
    align-items: center;
    padding: 10px 18px;
    border-radius: 15px;
    transition: all 0.3s ease;
    cursor: pointer;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      border-color: rgba(0, 242, 254, 0.3);
      box-shadow: 0 4px 15px rgba(0, 242, 254, 0.2);
      transform: translateY(-2px);
    }

    .el-avatar {
      box-shadow: 
        0 4px 12px rgba(0, 242, 254, 0.3),
        0 0 0 1px rgba(0, 242, 254, 0.2);
    }

    .username {
      margin-left: 12px;
      font-size: 14px;
      font-weight: 600;
      color: #e0e6ff;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    }

    .arrow-icon {
      margin-left: 8px;
      color: #a0a8b8;
      font-size: 12px;
      transition: transform 0.3s ease;
    }
  }
}

.main-content-container {
  flex: 1;
  overflow-y: auto;
  background: transparent;
  position: relative;

  .main-content {
    background: rgba(16, 20, 48, 0.6);
    backdrop-filter: blur(20px);
    box-shadow: 
      0 8px 40px rgba(0, 0, 0, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.05);
    padding: 0px;
    min-height: 100vh;
    border: 1px solid rgba(0, 242, 254, 0.1);
    position: relative;
  }
}

// 自定义滚动条
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
  border-radius: 6px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
}

::-webkit-scrollbar-corner {
  background: transparent;
}
.el-menu {
  border-right:none
}
// 响应式设计
@media (max-width: 768px) {
  .sidebar {
    width: 80px;
    
    .logo-title {
      display: none;
    }
  }
  
  .fixed-top .nav-center {
    gap: 10px;
    
    .info-item {
      padding: 8px 12px;
      font-size: 12px;
    }
  }
}
</style>